import React, {
  createRef,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import {
  Box,
  Text,
  useResponsiveWrapperContext,
  IcoMoon,
  AddIcon,
  RemoveIcon,
} from '@usap/uicomponents'
import { Title } from '@usap/widgets'
import seoIds from '../../../../config/seoIds'
import ArticleSubMenu from '../../seoComponents/Article/ArticleSubMenu'
import ArticleParagraph from '../../seoComponents/Article/ArticleParagraph'
import { ArticlesContext } from '../../../contexts/articles.context'
import { LocalContext } from '../../../helpers/useLocalContext'
import ArticleImage from './ArticleImage'
import ArticleHeading from './style/ArticleHeading'
import ArticleBox from './style/ArticleBox'
import ArticleMenu from './style/ArticleMenu'
import ArticleSection from './style/ArticleSection'

const H4EXP = /<h4>(?<text>.*?)<\/h4>/

const ArticleComponent = props => {
  const articles = useContext(ArticlesContext) || {}
  const { data: lazyRecords = [] } = articles
  const {
    id, image, altText, data: localRecords = [], title = '',
  } = props

  const records = useMemo(() => (localRecords !== null &&
          localRecords.length &&
            localRecords) || lazyRecords, [
    localRecords, lazyRecords,
  ])

  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  const refs = records.reduce((acc, record, index) => {
    acc[`article-id-${index}`] = createRef()
    const h4Arr = record.text.split(H4EXP)
    h4Arr.forEach((value, key) => {
      if (key % 2 === 1) {
        acc[`article-id-${index}-${key}`] = createRef()
      }
    })

    return acc
  }, {})

  const [collapseFlag, setCollapseFlag] = useState(true)
  const titleOnClickHandler = useCallback(
    () => setCollapseFlag(!collapseFlag),
    [collapseFlag, setCollapseFlag],
  )

  const margin = title ? 'auto' : '0px'
  const padding = title ? 'medium' : '0px'
  const hasArticleRecords = useMemo(
    () => Boolean(
      title && records !== null &&
      records.length &&
      (records[0]?.text !== '' ||
       (typeof records[1] !== 'undefined' && records[1]?.text !== '')
      ),
    ),
    [title, records],
  )

  const hideImageLoader = useCallback(e => {
    e.target.style.display = 'none'
  }, [])

  const styleMemo = useMemo(
    () => ({
      box1Marg: { horizontal: margin, vertical: '0px' },
      box1Pad: { vertical: padding, horizontal: padding },
      articleHeadingTitle: { fontSize: '20px' },
      articleTitle: { fontSize: '20px' },
      imageLoader: { marginTop: '16px', marginBottom: '16px' },
    }),
    [margin, padding],
  )

  const getHandleClick = currId => () => {
    refs[currId].current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <Box
      id={id}
      width="1248px"
      margin={styleMemo.box1Marg}
      pad={styleMemo.box1Pad}
      wrap="true"
      direction="row"
    >
      {hasArticleRecords && (
        <ArticleHeading id="articleHeading" title={title}>
          <Title
            type="h2"
            size="20px"
            label={title}
            style={styleMemo.articleHeadingTitle}
          />
          {!isDesktop && (
            <Box style={styleMemo.boxCollapse}>
              <Text onClick={titleOnClickHandler}>
                <IcoMoon icon={collapseFlag ? RemoveIcon : AddIcon} color="#393939" />
              </Text>
            </Box>
          )}
        </ArticleHeading>
      )}
      {collapseFlag && (
        <ArticleMenu id="articleMenu">
          {records.map(({ title: recordTitle, text: recordText }, index) => {
            const menuId = `article-menu-${index}`

            return (
              records.length && recordTitle && (
                <Box id={menuId} key={recordTitle}>
                  <ArticleSubMenu
                    menuIndex={index}
                    data={recordText}
                    refs={refs}
                    getHandleClick={getHandleClick}
                  />
                </Box>
              )
            )
          })}
        </ArticleMenu>
      )}
      {collapseFlag && (
      <ArticleSection id="articleSection">
        {records.map((record, index) => {
          const { title: recordTItle } = record
          const wrapperId = seoIds.article.replace('{{key}}', index)
          const titleMapKey = `article-id-${index}`
          const hasRecordImage = record.image && image
          return (
            <ArticleBox id={wrapperId} key={recordTItle} isLast={records.length === index + 1}>
              {hasRecordImage && (
                <ArticleImage
                  layout="fixed"
                  src={image}
                  isBot={isBot}
                  alt={altText}
                  style={styleMemo.imageLoader}
                  onError={hideImageLoader}
                />
              )}
              <ArticleParagraph data={record.text} prefArticleId={`${titleMapKey}-`} refs={refs} />
            </ArticleBox>
          )
        })}
      </ArticleSection>
      )}
    </Box>
  )
}

export default ArticleComponent
